interface RiskOption {
  value: string;
  defaultStopLoss?: number | null;
  name?: string;
}

interface StrategyWithConfig {
  name?: string;
  configOptions?: Record<string, unknown> | null;
}

import type { AdvancedStopLoss } from "@investhinks/api-client";

interface StoplossConfig {
  advancedStopLoss?: AdvancedStopLoss | null;
  risk?: string;
}

function getRiskOptions(configOptions: Record<string, unknown> | null | undefined): RiskOption[] {
  if (!configOptions) return [];
  const raw = configOptions.riskOptions;
  if (!Array.isArray(raw)) return [];
  return raw.filter(
    (item: unknown): item is RiskOption =>
      typeof item === "object" && item !== null && "value" in item && typeof item.value === "string"
  );
}

export const getDefaultStoploss = (strategy: StrategyWithConfig | null | undefined, risk: string | undefined) =>
  getRiskOptions(strategy?.configOptions).find((r) => r.value === risk)?.defaultStopLoss || null;

const getStoploss = (strategy: StrategyWithConfig | null | undefined, config: StoplossConfig = {}) => {
  const { stopLossEnabled, useCustomStopLoss, customStopLoss } = config.advancedStopLoss ?? {};
  return stopLossEnabled !== false
    ? useCustomStopLoss
      ? customStopLoss
      : getDefaultStoploss(strategy, config.risk)
    : null;
};

export default getStoploss;
